module.exports = __webpack_public_path__ + "img/20220219_071647.81ad7c55.jpg";